/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotosubtitle3Inputs */

const en_aiflowphotosubtitle3 = /** @type {(inputs: Aiflowphotosubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date and place`)
};

const de_aiflowphotosubtitle3 = /** @type {(inputs: Aiflowphotosubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum und Ort`)
};

/**
* | output |
* | --- |
* | "Date and place" |
*
* @param {Aiflowphotosubtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotosubtitle3 = /** @type {((inputs?: Aiflowphotosubtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotosubtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotosubtitle3(inputs)
	return de_aiflowphotosubtitle3(inputs)
});
export { aiflowphotosubtitle3 as "aiFlowPhotoSubtitle" }